import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class InsReportSrcQueryService {
    public CREATE_INSPECTION_REPORT_DATA: any;
    public UPDATE_ALTER_EMAIL_DATA: any;
    public GIS_INS_REPORT_EXIST_BY_ORDERID: any;

    constructor(public apollo: Apollo) {
        //Create inspection report  detail
        this.CREATE_INSPECTION_REPORT_DATA = gql` 
        mutation CREATE_INSPECTION_REPORT_MUTATION($input: CreateInspectionReportsSrcInput!) {
            createInspectionReportsSrc(input: $input) {
                inspectionReportsSrc{
                    orderId
                    insReportId         
                }
        }
        }
    `;

        this.UPDATE_ALTER_EMAIL_DATA = gql` 
            mutation myMutation($input: UpdateInspectionReportsSrcInput!){
                updateInspectionReportsSrc(input: $input){
                    inspectionReportsSrc{
                     alterEmail
                     }
                }
            }
            `;

        //Get report from inspection report
        this.GIS_INS_REPORT_EXIST_BY_ORDERID =
            gql`     
          query getInspectionReportsSrcs($orderId:Int!){                           
          allInspectionReportsSrcs(condition:{orderId:$orderId}) {
            edges {
              node {
                insReportId   
                nodeId
                alterEmail 
                solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                    nodes{  
                      roleid           
                      roleByRoleid{
                        roleId
                        roleName
                      } 
                      userByUserid {
                        userId
                        firstName
                      }
                      createdat
                    }
                  }           
              }
            }
          }  
        }
      `;
    }

    CREATE_INSPECTION_REPORT_MUTATION(orderId, randomId) {
        return this.apollo.mutate({
            mutation: this.CREATE_INSPECTION_REPORT_DATA,
            variables: {
                "input": {
                    "inspectionReportsSrc": {
                        "orderId": Number.parseInt(orderId),
                        "insReportId": randomId,
                    }
                }
            },
        })
    }

    //get all orders based on address
    IS_INS_REPORT_EXIST(orderId): any {
        return this.apollo
            .watchQuery({
                query: this.GIS_INS_REPORT_EXIST_BY_ORDERID
                ,
                variables:
                {
                    "orderId": Number.parseInt(orderId),
                },
                fetchPolicy: 'network-only'
            });
    }

    /**Alter email id */
    ALTER_EMAIL_ID_MUTATION(orderId, email, reviewNodeId) {

        return this.apollo.mutate({
            mutation: this.UPDATE_ALTER_EMAIL_DATA,
            variables: {
                "input": {
                    "inspectionReportsSrcPatch":
                    {
                        "orderId": Number.parseInt(orderId),
                        "alterEmail": email,
                    },
                    "nodeId": reviewNodeId
                }

            },
            fetchPolicy: 'no-cache'
        })
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/insReportSrc.ts